import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home/Home.vue'),
    },
    {
      path: '/preview/:x',
      name: 'Visualizador',
      component: () => import('@/views/Preview/Preview.vue'),
      meta: (route, store) => ({
        pageTitle: 'Visualizador',
        breadcrumb: [
          {
            text: 'Inicio',
            to: '/',
          },
          {
            text: store.getters['ediciones/nombreEdicion'](route.params.x),
            active: true,
          },
        ],
      }),
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/Error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
